"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BlockVideoParams = exports.BlockVideoTopEditor = exports.BlockVideo = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

var _immer = _interopRequireDefault(require("immer"));

var _io = require("react-icons/io5");

var _recoil = require("recoil");

var _RecoilStates = require("../../contexts/RecoilStates");

var _Youtube = require("../../helpers/Youtube");

var _VideoYoutube = _interopRequireDefault(require("../VideoYoutube"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * @param {{block: import("../../../types/blocks").BlockVideo}} param0
 */
var BlockVideo = function BlockVideo(_ref) {
  var _block$content$intl$l, _block$content$intl$l2, _block$content$intl$d;

  var block = _ref.block;

  var _useState = (0, _react.useState)(false),
      isCtrlKeyDown = _useState[0],
      setIsCtrlKeyDown = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var bgColor = (0, _react2.useColorModeValue)("white", "gray.700");
  var refVideo = (0, _react.useRef)(
  /** @type {HTMLVideoElement | null} */
  null);
  var src = (_block$content$intl$l = (_block$content$intl$l2 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l2.source) != null ? _block$content$intl$l : (_block$content$intl$d = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d.source;
  (0, _react.useEffect)(function () {
    var _refVideo$current;

    (_refVideo$current = refVideo.current) == null ? void 0 : _refVideo$current.load();
  }, [src]);
  (0, _react.useEffect)(function () {
    /**
     * @param {KeyboardEvent} event
     */
    var handlerKeyDown = function handlerKeyDown(event) {
      if (event.key === "Control") {
        setIsCtrlKeyDown(true);
      }
    };

    window.addEventListener("keydown", handlerKeyDown);
    /**
     * @param {KeyboardEvent} event
     */

    var handlerKeyUp = function handlerKeyUp(event) {
      if (event.key === "Control") {
        setIsCtrlKeyDown(false);
      }
    };

    window.addEventListener("keyup", handlerKeyUp);

    var handlerFocus = function handlerFocus(event) {
      setIsCtrlKeyDown(false);
    };

    window.addEventListener("focus", handlerFocus);
    return function () {
      window.removeEventListener("keydown", handlerKeyDown);
      window.removeEventListener("keyup", handlerKeyUp);
      window.removeEventListener("focus", handlerFocus);
    };
  }, []);
  var idVideoYoutube = (0, _Youtube.getYoutubeId)(src);
  var isYoutubeVideo = Boolean(idVideoYoutube);
  return __jsx(_react2.Box, {
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    }
  }, __jsx(_react2.Box, {
    pointerEvents: isCtrlKeyDown ? "all" : "none"
  }, isYoutubeVideo ? __jsx(_VideoYoutube["default"], {
    id: String(idVideoYoutube),
    showControls: block.content.controls
  }) : __jsx("video", {
    ref: refVideo,
    controls: block.content.controls,
    autoPlay: false,
    width: "100%"
  }, __jsx("source", {
    src: src
  }), __jsx(_react2.Text, null, "Votre navigateur ne supporte pas les balises vid\xE9os"))), __jsx(_react2.Fade, {
    "in": !isCtrlKeyDown && hovered,
    unmountOnExit: true
  }, __jsx(_react2.Center, {
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0"
  }, __jsx(_react2.HStack, {
    backgroundColor: bgColor,
    borderRadius: "md",
    boxShadow: "sm",
    mx: 2,
    padding: "4"
  }, __jsx(_react2.Text, null, "Appuyer"), __jsx("span", null, __jsx(_react2.Kbd, null, "ctrl")), __jsx(_react2.Text, null, "pour interagir avec la video")))));
};
/**
 * @param {import("../../../types/types").BlockSubComponentProps<import("../../../types/blocks").BlockVideo>} props
 */


exports.BlockVideo = BlockVideo;

var BlockVideoTopEditor = function BlockVideoTopEditor(_ref2) {
  var _block$content$intl$l3, _block$content$intl$l4, _block$content$intl$d2, _block$content$intl$l5;

  var block = _ref2.block,
      onUpdate = _ref2.onUpdate;
  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var src = (_block$content$intl$l3 = (_block$content$intl$l4 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l4.source) != null ? _block$content$intl$l3 : (_block$content$intl$d2 = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d2.source;

  var onInputSourceChange = function onInputSourceChange(event) {
    var _block = (0, _immer["default"])(block, function (draft) {
      if (!draft.content.intl[language.key]) {
        draft.content.intl[language.key] = {
          source: ""
        };
      }

      draft.content.intl[language.key].source = event.target.value;
    });

    onUpdate(_block);
  };

  return __jsx(_react2.Box, null, __jsx(_react2.Input, {
    value: src,
    onChange: onInputSourceChange,
    placeholder: "https://...",
    variant: "filled"
  }), __jsx(_react2.Collapse, {
    "in": !((_block$content$intl$l5 = block.content.intl[language.key]) != null && _block$content$intl$l5.source)
  }, __jsx(_react2.Flex, {
    ml: "4",
    alignItems: "center",
    color: "gray.400"
  }, __jsx(_react2.Icon, {
    as: _io.IoChevronForwardOutline
  }), __jsx(_react2.Text, null, "Valeur par d\xE9faut utilis\xE9e"))));
};
/**
 * @param {import("../../../types/types").BlockSubComponentProps<import("../../../types/blocks").BlockVideo>} props
 */


exports.BlockVideoTopEditor = BlockVideoTopEditor;

var BlockVideoParams = function BlockVideoParams(_ref3) {
  var _block$content$intl$l6, _block$content$intl$l7, _block$content$intl$d3;

  var block = _ref3.block,
      onUpdate = _ref3.onUpdate;

  var updateContentProps = function updateContentProps(changes) {
    var _block = (0, _immer["default"])(block, function (draft) {
      Object.keys(changes).forEach(function (key) {
        draft.content[key] = changes[key];
      });
    });

    onUpdate(_block);
  };

  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var src = (_block$content$intl$l6 = (_block$content$intl$l7 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l7.source) != null ? _block$content$intl$l6 : (_block$content$intl$d3 = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d3.source;
  var isYoutubeVideo = Boolean((0, _Youtube.getYoutubeId)(src));
  return __jsx(_react2.Stack, {
    spacing: "8px"
  }, __jsx(_react2.Text, {
    fontWeight: "bold"
  }, "Vid\xE9o"), __jsx(_react2.Box, null, __jsx(_react2.FormControl, {
    display: "flex",
    alignItems: "center"
  }, __jsx(_react2.FormLabel, {
    flexGrow: 1,
    fontWeight: "normal",
    mb: "0",
    htmlFor: "switch-controls"
  }, "Contr\xF4les"), __jsx(_react2.Switch, {
    id: "switch-controls",
    isChecked: block.content.controls,
    onChange: function onChange(event) {
      return updateContentProps({
        controls: event.target.checked
      });
    }
  })), !isYoutubeVideo && __jsx(_react2.FormControl, {
    display: "flex",
    alignItems: "center"
  }, __jsx(_react2.FormLabel, {
    flexGrow: 1,
    fontWeight: "normal",
    mb: "0",
    htmlFor: "switch-autoplay"
  }, "Lecture automatique"), __jsx(_react2.Switch, {
    id: "switch-autoplay",
    isChecked: block.content.autoplay,
    onChange: function onChange(event) {
      return updateContentProps({
        autoplay: event.target.checked
      });
    }
  }))));
};

exports.BlockVideoParams = BlockVideoParams;